// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@mcmc/XDL/Helpers";
import { css } from "styled-components";

customerCardStyles.container = {
    css: css`
        padding: 15px 0;
        border-top: 1px solid ${getColor("common.border")};
    `,
};
customerCardStyles.addressGridItem = { width: [12, 12, 6, 6, 6] };
customerCardStyles.actionsGridItem = { width: [12, 12, 6, 6, 6], css: css`` };
customerCardStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-left: auto;
        align-items: center;
        ${screen("lte", "sm")`flex-direction:row;margin-left:0;`}
    `,
};
customerCardStyles.selectButton = {
    variant: "secondary",
    sizeVariant: "small",
    css: css`
        min-width: 100px;
    `,
};

customerCardStyles.editLink = {
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        margin-top: 15px;
        ${screen("lte", "sm")`margin-top: 0;margin-left:10px;`}
    `,
};
